import { FunctionType } from './shared/enums/function-type.enum';

export enum WallColor {
    black,
    white
}

export class WallSharedConstants {

    public static DEFAULT_MONITOR_ROTATED_ANGLE = 180;
    public static DEFAULT_MONITOR_ANGLE = 0;
    public static DEFAULT_MONITOR_LEFT = 120;
    public static DEFAULT_CELL_WIDTH = 71;
    public static DEFAULT_MONITOR_TOP = 45;
    public static DEFAULT_MONITOR_TYPE: number = FunctionType.iDisplay;
    public static MAX_WALLS_QUANTITY = 16;

    public static DEFAULT_RETICULUM_MONITOR_WIDTH = 71.11111111;
    public static DEFAULT_PRESET_QUALITY = 90;
    public static DEFAULT_PRESET_NAME = '';

    public static DEFAULT_WALL_ZOOM = 1;
    public static MAX_RETICULUM_ZOOM = 1;
    public static MIN_RETICULUM_ZOOM = 0.35;
    public static RETICULUM_ZOOM_STEP = 0.05;

    public static MAX_ANGLE_VALIDATION_VALUE = 360;
    public static DEFAULT_ARTISTIC_CANVAS_WIDTH = 600;
    public static DEFAULT_ARTISTIC_CANVAS_HEIGTH = 300;
    public static DEFAULT_RETICULUM_CANVAS_WIDTH = 600;
    public static DEFAULT_RETICULUM_CANVAS_HEIGTH = 245;

    public static MONITOR_IDENTIFIER = 'ScreenName'; // "Id"
    public static LOCAL_STORAGE_DND_KEY = 'dnd';

    public static WALL_MIN_ZOOM = 0.5;
    public static WALL_MAX_ZOOM = 3;
    public static WALL_ZOOM_STEP = 0.1;
    public static WALL_ZERO_X = 0;
    public static WALL_ZERO_Y = 0;
    public static WALL_OFFSET_X = 0;
    public static WALL_OFFSET_Y = 0;

    // front end constants
    public static FABRICJS_OBJECT_CORNER_COLOR = '#ababab';
    public static FABRICJS_OBJECT_BORDER_COLOR = '#636161';
    public static FABRICJS_ARTISTIC_BORDER_COLOR = '#f53e80'; // '#1ba8ed';
    public static FABRICJS_CREATIVE_MODE_FILL_COLOR = 'transparent';
    public static FABRICJS_ARTISTIC_SCREEN_BORDER_COLOR = '#1ba8ed';

    public static DEFAULT_MONITOR_TEXT_SIZE = 18;
    public static DEFAULT_WALL_RESOLUTION_W = 1920;
    public static DEFAULT_WALL_RESOLUTION_H = 1080;
    public static DEFAULT_WALL_IS_ALIGNED = true;
    public static WALL_RATIO = 27;
    public static DEFAULT_MONITOR_WIDTH: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_W / WallSharedConstants.WALL_RATIO;
    public static DEFAULT_MONITOR_HEIGTH: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_H / WallSharedConstants.WALL_RATIO;

    public static SERVICE_ELEMENT_IDENTIFIER = 'serviseElement';
    public static WALL_KEYBOARD_STEP = 1 / WallSharedConstants.WALL_RATIO;
    public static WALL_PAN_STEP = 20;

    public static DEFAULT_NUMBER_OF_DISPLAYS: number = 1;
    public static IMAGE_URL_PATH = '/../assets/img/';
    public static EXTENDED_SELECTION_AREA_CLASS_NAME = 'extended-screens-container';
    public static MIRROR_SELECTION_AREA_CLASS_NAME = 'mirror-screens-container';
    public static MIRROR_SELECTION_PLACEHOLDER_CLASS_NAME = 'mirror-screens-container-placeholder';

    public static WALL_CONTROLS_THEME = WallColor.white;
    public static FABRIC_RIGHT_BUTTON_KEY_CODE = 3;

    public static WALL_CONTROLS_COLOR = WallSharedConstants.WALL_CONTROLS_THEME.toString();

    // Selection
    public static DEFAULT_SELECTION_CLASS_NAME = 'wall-selection';
    public static SELECTION_MONITOR_TAG_NAME = 'wall-monitor';
    public static SELECTED_MONITOR_CLASS_NAME = 'monitor--selected';
    public static SELECTION_START_THRESHOLD_VALUE = 20;

    // picture pathes
    public static WALL_BACKGROUND_IMAGE = `${WallSharedConstants.IMAGE_URL_PATH}3px-tile.png`;
    public static WALL_MONITORS_IMAGE = `${WallSharedConstants.IMAGE_URL_PATH}wall-background.jpg`;
    public static WALL_CALIBRATION_IMAGE = `${WallSharedConstants.IMAGE_URL_PATH}web.jpg`;
    public static WALL_ICON_WHITE_SETTINGS_PATH = `${WallSharedConstants.IMAGE_URL_PATH}settings-symbol.png`;
    public static WALL_ICON_WHITE_DELETE_PATH = `${WallSharedConstants.IMAGE_URL_PATH}delete-white.png`;
    public static WALL_ICON_WHITE_ROTATE_PATH = `${WallSharedConstants.IMAGE_URL_PATH}clockwise-circular-arrow.png`;
    public static WALL_ICON_BLACK_DELETE_PATH = `${WallSharedConstants.IMAGE_URL_PATH}delete-black.png`;
    public static WALL_ICON_BLACK_SETTINGS_PATH = `${WallSharedConstants.IMAGE_URL_PATH}settings-symbol-black.png`;
    public static WALL_ICON_BLACK_ROTATE_PATH = `${WallSharedConstants.IMAGE_URL_PATH}clockwise-circular-arrow-black.png`;
    public static SCREEN_PROPERTY_SET_DEFAULT_VALUE_PATH = `${WallSharedConstants.IMAGE_URL_PATH}set-default.png`;

    public static WALL_ICON_SETTINGS_PATH = WallSharedConstants.WALL_CONTROLS_THEME === WallColor.black ?
        WallSharedConstants.WALL_ICON_BLACK_SETTINGS_PATH : WallSharedConstants.WALL_ICON_WHITE_SETTINGS_PATH;
    public static WALL_ICON_DELETE_PATH = WallSharedConstants.WALL_CONTROLS_THEME === WallColor.black ?
        WallSharedConstants.WALL_ICON_BLACK_DELETE_PATH : WallSharedConstants.WALL_ICON_WHITE_DELETE_PATH;
    public static WALL_ICON_ROTATE_PATH = WallSharedConstants.WALL_CONTROLS_THEME === WallColor.black ?
        WallSharedConstants.WALL_ICON_BLACK_ROTATE_PATH : WallSharedConstants.WALL_ICON_WHITE_ROTATE_PATH;

    // Monitor colors
    public static ARTISTIC_MONITOR_COLOR = '#fffffa';
    public static RETICULUM_MONITOR_COLOR = '#1ba8ed';
    public static INACTIVE_MONITOR_COLOR = '#c1c1c1';
}
